// Scoped styles for the Member Engagement tracker. Everything is nested under
// `.met-scope` so the tracker's generic class/element rules cannot leak into the
// rest of the admin app.
const css = `
.met-scope{
  --bg:#FFFFFF; --surface:#FFFFFF; --ink:#16161A; --soft:#6B6B72; --faint:#9A9AA0;
  --line:#EAE7E1; --line-2:#DEDAD2; --wash:#F4F2EE;
  --accent:#E8392E; --accent-soft:#FCEBE9;
  --good:#1F8A5B; --good-soft:#E7F3EC;
  --warn:#C2791E; --warn-soft:#FBF0DD;
  --serif:"ivypresto-headline",Georgia,serif;
  --sans:"indivisible","Neue Montreal","Helvetica Neue",Arial,sans-serif;
  --shadow:0 1px 2px rgba(20,20,26,.04),0 8px 24px -12px rgba(20,20,26,.12);
  --shadow-lg:0 24px 60px -20px rgba(20,20,26,.34);
  background:var(--bg);color:var(--ink);font-family:var(--sans);font-size:14px;line-height:1.5;-webkit-font-smoothing:antialiased;
}
.met-scope *{box-sizing:border-box}
.met-scope a{color:inherit}
.met-scope :focus-visible{outline:2px solid var(--accent);outline-offset:2px;border-radius:4px}

.met-scope .topbar{position:sticky;top:0;z-index:20;background:rgba(251,250,248,.86);backdrop-filter:blur(10px);border-bottom:1px solid var(--line)}
.met-scope .topbar .in{max-width:1240px;margin:0 auto;padding:16px 28px;display:flex;align-items:center;gap:16px}
.met-scope .brand{display:flex;align-items:baseline;gap:10px}
.met-scope .brand .mark{font-family:var(--serif);font-weight:700;font-size:26px;letter-spacing:-.01em}
.met-scope .brand .mark .dot{color:var(--accent)}
.met-scope .brand .divr{width:1px;height:22px;background:var(--line-2);margin:0 2px;align-self:center}
.met-scope .brand .ttl{font-size:13px;font-weight:600;color:var(--soft);letter-spacing:.02em}
.met-scope .topbar .spacer{flex:1}
.met-scope .topbar .q{font-size:12.5px;color:var(--faint)}

.met-scope .page{max-width:none;margin:0;padding:8px 0 40px}
.met-scope .lede{font-family:var(--serif);font-weight:600;font-size:clamp(26px,3.4vw,38px);line-height:1.08;letter-spacing:-.01em;margin:0 0 6px}
.met-scope .lede em{font-style:italic;color:var(--accent)}
.met-scope .sub{color:var(--soft);max-width:62ch;margin:0 0 26px}

.met-scope .kpis{display:grid;grid-template-columns:repeat(auto-fit,minmax(186px,1fr));gap:14px;margin-bottom:14px}
.met-scope .kpi{background:var(--surface);border:1px solid var(--line);border-radius:14px;padding:16px 18px;box-shadow:var(--shadow);min-width:0}
.met-scope .kpi .lab{font-size:11.5px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--faint)}
/* Flex so the unit suffix (%, /mo) wraps INSIDE the card when the figure is
   long (e.g. "₹20,000/mo") instead of spilling past the card's right edge.
   Card width is the auto-fit grid cell, independent of the viewport, so
   wrapping — not viewport-based scaling — is what keeps it contained at every
   resolution. overflow-wrap is a last-resort guard for very narrow cells. */
.met-scope .kpi .val{font-family:var(--serif);font-weight:700;font-size:18px;line-height:1;margin-top:8px;letter-spacing:-.01em;display:flex;flex-wrap:wrap;align-items:baseline;min-width:0;overflow-wrap:break-word}
.met-scope .kpi .val small{font-size:12px;color:var(--soft);font-family:var(--sans);font-weight:600;margin-left:2px}
.met-scope .kpi .note{font-size:12px;color:var(--soft);margin-top:7px}
.met-scope .kpi.alert{border-color:#F4C9C5;background:linear-gradient(180deg,#fff, #FFF7F6)}
.met-scope .kpi.alert .val{color:var(--accent)}

.met-scope .health{background:var(--surface);border:1px solid var(--line);border-radius:14px;padding:16px 18px;box-shadow:var(--shadow);margin-bottom:26px}
.met-scope .health .top{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:12px}
.met-scope .health .lab{font-size:11.5px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--faint)}
.met-scope .health .legend{display:flex;gap:18px;font-size:12px;color:var(--soft);flex-wrap:wrap}
.met-scope .health .legend i{width:9px;height:9px;border-radius:3px;display:inline-block;margin-right:6px;vertical-align:middle}
.met-scope .bar{height:20px;border-radius:7px;overflow:hidden;display:flex;background:var(--wash)}
.met-scope .bar span{display:flex;align-items:center;justify-content:center;height:100%;color:#fff;font-size:11px;font-weight:700;line-height:1;overflow:hidden;white-space:nowrap}
.met-scope .seg-good{background:var(--good)} .met-scope .seg-warn{background:var(--warn)} .met-scope .seg-risk{background:var(--accent)}

.met-scope .controls{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-bottom:16px}
.met-scope .search{flex:1;min-width:220px;position:relative}
.met-scope .search input{width:100%;padding:11px 14px 11px 38px;border:1px solid var(--line-2);border-radius:10px;font:inherit;background:var(--surface);color:var(--ink)}
.met-scope .search svg{position:absolute;left:12px;top:50%;transform:translateY(-50%);width:16px;height:16px;stroke:var(--faint);fill:none;stroke-width:2}
.met-scope .chips{display:flex;gap:6px;background:var(--wash);padding:4px;border-radius:11px}
.met-scope .chip{border:0;background:transparent;font:inherit;font-weight:600;font-size:12.5px;color:var(--soft);padding:7px 13px;border-radius:8px;cursor:pointer;transition:.15s;white-space:nowrap}
.met-scope .chip[aria-pressed="true"]{background:var(--surface);color:var(--ink);box-shadow:var(--shadow)}
.met-scope .chip .n{color:var(--faint);font-weight:600;margin-left:5px}
.met-scope select.sort{font:inherit;font-weight:500;padding:10px 14px;border:1px solid var(--line-2);border-radius:10px;background:var(--surface);color:var(--ink);cursor:pointer}

.met-scope .tablewrap{background:var(--surface);border:1px solid var(--line);border-radius:16px;box-shadow:var(--shadow);overflow:hidden}
.met-scope .scroll{overflow-x:auto}
/* Sticky header pinned to the PAGE scroll (matches Channel Attribution).
   top:4.5rem clears the app's sticky .navbar-header (4.5rem tall); z-index stays
   under that bar's z-index:2 so the header slides beneath it. BOTH ancestors have
   to stop clipping: any overflow value makes an element a scroll container, and
   the header would then stick to it (i.e. never move) instead of to the viewport
   — .tablewrap clips for its rounded corners and .scroll is the horizontal
   scroller. The trade-off is that the card's corners don't clip the table while
   pinned, which is invisible in practice since the header covers the top edge.
   border-collapse drops borders on sticky cells, hence the box-shadow line.
   Below 1400px the content column is narrower than the table's 840px min-width,
   so both go back to clipping/scrolling and the header un-sticks. */
.met-scope .tablewrap.stickyhead{overflow:visible}
.met-scope .tablewrap.stickyhead .scroll{overflow:visible}
.met-scope .tablewrap.stickyhead thead th{position:sticky;top:4.5rem;z-index:1;background:var(--surface);box-shadow:inset 0 -1px 0 var(--line)}
@media(max-width:1399px){
  .met-scope .tablewrap.stickyhead{overflow:hidden}
  .met-scope .tablewrap.stickyhead .scroll{overflow-x:auto}
  .met-scope .tablewrap.stickyhead thead th{position:static;box-shadow:none}
}
.met-scope table{width:100%;border-collapse:collapse;min-width:840px}
.met-scope thead th{text-align:left;font-size:11px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:var(--faint);padding:14px 16px;border-bottom:1px solid var(--line);white-space:nowrap}
.met-scope thead th.num{text-align:right}
.met-scope tbody tr{border-bottom:1px solid var(--line);cursor:pointer;transition:background .12s}
.met-scope tbody tr:last-child{border-bottom:0}
.met-scope tbody tr:hover{background:var(--wash)}
.met-scope td{padding:14px 16px;vertical-align:middle}
.met-scope td.num{text-align:right;font-variant-numeric:tabular-nums;font-weight:600}
.met-scope .member{display:flex;align-items:center;gap:12px;min-width:200px}
.met-scope .ava{width:40px;height:40px;border-radius:50%;flex-shrink:0;display:grid;place-items:center;color:#fff;font-family:var(--serif);font-weight:700;font-size:16px;background:linear-gradient(135deg,#F2625A,#D9281C);position:relative}
.met-scope .ava.sm{width:30px;height:30px;font-size:13px}
.met-scope .ava.them{background:linear-gradient(135deg,#5b5b66,#2c2c34)}
.met-scope .m-name{font-weight:600}
.met-scope .del-tag{display:inline-block;margin-left:6px;padding:1px 7px;border-radius:999px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;background:#fdeaea;color:#c0392b;vertical-align:middle}
.met-scope .m-sub{font-size:12px;color:var(--faint)}
.met-scope .plan{display:inline-block;font-size:10.5px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:3px 8px;border-radius:999px;border:1px solid var(--line-2);color:var(--soft)}
/* Chip colours are keyed on the PLAN KEY the API sends, lower-cased by planCls:
   lux | luxf | gold | goldf. They used to be .diamond / .platinum, tiers that do
   not exist in the catalogue — so every real plan fell through to the plain
   default. Gender variants share their tier's colour; the label carries the
   variant. */
.met-scope .plan.lux,
.met-scope .plan.luxf{color:#6C4CB6;border-color:#D6CCF0;background:#F4EFFC}
.met-scope .plan.gold,
.met-scope .plan.goldf{color:#9A7A1E;border-color:#EBDDB4;background:#FBF5E3}

.met-scope .meter{display:flex;align-items:center;gap:10px;min-width:150px}
.met-scope .meter .track{flex:1;height:8px;border-radius:5px;background:var(--wash);overflow:hidden;min-width:70px}
.met-scope .meter .fill{height:100%;border-radius:5px}
.met-scope .meter .pct{font-variant-numeric:tabular-nums;font-weight:700;width:38px;text-align:right}
.met-scope .fill.good{background:var(--good)} .met-scope .fill.warn{background:var(--warn)} .met-scope .fill.risk{background:var(--accent)}

.met-scope .pill{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:600;padding:5px 10px;border-radius:999px;white-space:nowrap}
.met-scope .pill i{width:7px;height:7px;border-radius:50%}
.met-scope .pill.good{background:var(--good-soft);color:var(--good)} .met-scope .pill.good i{background:var(--good)}
.met-scope .pill.warn{background:var(--warn-soft);color:var(--warn)} .met-scope .pill.warn i{background:var(--warn)}
.met-scope .pill.risk{background:var(--accent-soft);color:var(--accent)} .met-scope .pill.risk i{background:var(--accent)}
.met-scope .cellmeta{font-size:12px;color:var(--faint);margin-top:2px}

.met-scope .empty{padding:48px 20px;text-align:center;color:var(--soft)}

.met-scope .overlay{position:fixed;inset:0;background:rgba(20,20,26,.32);opacity:0;visibility:hidden;transition:.2s;z-index:1300}
.met-scope .overlay.open{opacity:1;visibility:visible}
.met-scope .drawer{position:fixed;top:0;right:0;height:100%;width:min(580px,94vw);background:var(--bg);box-shadow:var(--shadow-lg);z-index:1310;transform:translateX(100%);transition:transform .26s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column}
.met-scope .drawer.open{transform:none}
.met-scope .dhead{padding:20px 24px;border-bottom:1px solid var(--line);background:var(--surface)}
.met-scope .dhead .row1{display:flex;align-items:center;gap:14px}
.met-scope .dhead .x{margin-left:auto;border:1px solid var(--line-2);background:var(--surface);width:34px;height:34px;border-radius:9px;cursor:pointer;display:grid;place-items:center;color:var(--soft)}
.met-scope .dhead .x:hover{color:var(--ink);border-color:var(--ink)}
.met-scope .dhead h2{font-family:var(--serif);font-weight:700;font-size:20px;margin:0;letter-spacing:-.01em}
.met-scope .dhead .meta{font-size:12.5px;color:var(--faint);margin-top:2px}
.met-scope .dstats{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-top:16px}
.met-scope .dstat{background:var(--bg);border:1px solid var(--line);border-radius:11px;padding:10px 12px}
.met-scope .dstat .l{font-size:10.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:var(--faint)}
.met-scope .dstat .v{font-family:var(--serif);font-weight:700;font-size:18px;line-height:1.1;margin-top:3px}
.met-scope .dstat .v.risk{color:var(--accent)} .met-scope .dstat .v.good{color:var(--good)}

.met-scope .dbody{flex:1;overflow:auto;padding:18px 24px 30px}
.met-scope .dsec{font-size:11.5px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--faint);margin:6px 0 12px}
.met-scope .conv{background:var(--surface);border:1px solid var(--line);border-radius:14px;margin-bottom:14px;overflow:hidden}
.met-scope .conv-head{display:flex;align-items:center;gap:11px;padding:13px 15px;cursor:pointer}
.met-scope .conv-head .who{font-weight:600}
.met-scope .utype{display:inline-block;font-size:9.5px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:1px 6px;border-radius:999px;vertical-align:middle;margin-left:4px}
.met-scope .utype.bot{color:#6C4CB6;background:#F4EFFC;border:1px solid #D6CCF0}
.met-scope .utype.real{color:var(--good);background:var(--good-soft);border:1px solid #C7E6D4}
.met-scope .conv-head .cm{font-size:12px;color:var(--faint);margin-top:1px;font-weight:400}
.met-scope .conv-head .tag{margin-left:auto}
.met-scope .tag{display:inline-flex;align-items:center;gap:5px;font-size:11.5px;font-weight:600;padding:4px 9px;border-radius:999px;white-space:nowrap}
.met-scope .tag.replied{background:var(--good-soft);color:var(--good)}
.met-scope .tag.slow{background:var(--warn-soft);color:var(--warn)}
.met-scope .tag.none{background:var(--accent-soft);color:var(--accent)}
/* Inbound thread — the MEMBER is the one who never replied. Deliberately not the
   accent used by .tag.none: that flags a match ignoring the member, the opposite
   finding, and the two sit in the same list. */
.met-scope .tag.ignored{background:#EEF1F6;color:#5A6478;border:1px solid #DCE1EA}
/* Divider between the outbound threads and the inbound-only ones below them. */
.met-scope .convsplit{display:flex;align-items:center;gap:10px;margin:22px 0 10px;font-size:12px;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:var(--faint)}
.met-scope .convsplit::after{content:'';flex:1;height:1px;background:var(--line)}
.met-scope .convsplit .hint{font-weight:400;letter-spacing:0;text-transform:none;color:var(--soft)}
.met-scope .chev{width:16px;height:16px;stroke:var(--faint);fill:none;stroke-width:2;transition:.2s;flex-shrink:0}
.met-scope .conv.open .chev{transform:rotate(180deg)}
.met-scope .thread{display:none;padding:4px 15px 16px;border-top:1px solid var(--line);background:linear-gradient(180deg,var(--wash),transparent 60px)}
.met-scope .conv.open .thread{display:block}
.met-scope .bubble{max-width:80%;padding:9px 13px;border-radius:14px;margin:10px 0 2px;font-size:13.5px;position:relative}
.met-scope .bubble .sender{display:block;font-size:10.5px;font-weight:700;letter-spacing:.02em;margin-bottom:3px;opacity:.85}
.met-scope .bubble time{display:block;font-size:10.5px;margin-top:5px;opacity:.7}
.met-scope .bubble .msg-media{display:inline-flex;align-items:center;gap:2px;font-style:italic;opacity:.95}
.met-scope .bubble .mi-ico{font-style:normal;margin-right:4px}
.met-scope .bubble.me{margin-left:auto;background:var(--accent);color:#fff;border-bottom-right-radius:5px}
.met-scope .bubble.them{background:#fff;border:1px solid var(--line-2);border-bottom-left-radius:5px}
.met-scope .lat{display:flex;align-items:center;gap:8px;justify-content:center;margin:12px 0;font-size:11.5px;color:var(--soft)}
.met-scope .lat::before,.met-scope .lat::after{content:"";height:1px;background:var(--line);flex:1}
.met-scope .lat b{font-weight:600}
.met-scope .lat.slow b{color:var(--warn)} .met-scope .lat.fast b{color:var(--good)}
.met-scope .waiting{text-align:center;margin:12px 0 4px;font-size:12px;font-weight:600;color:var(--accent)}

.met-scope .foot{max-width:none;margin:24px 0 0;padding:0;font-size:12px;color:var(--faint)}
.met-scope .foot b{color:var(--soft);font-weight:600}

.met-scope .subcard{margin-top:14px;padding-top:14px;border-top:1px dashed var(--line-2)}
.met-scope .sc-row{display:flex;gap:20px;flex-wrap:wrap;margin-bottom:9px}
.met-scope .sc-row:last-child{margin-bottom:0}
.met-scope .sc-i{min-width:118px}
.met-scope .sc-i .l{font-size:10.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:var(--faint)}
.met-scope .sc-i .v2{font-size:13.5px;font-weight:600;margin-top:3px}
.met-scope .sub-pill{display:inline-block;font-size:11px;font-weight:700;padding:3px 9px;border-radius:999px}
.met-scope .sub-pill.active{background:var(--good-soft);color:var(--good)}
.met-scope .sub-pill.cancels{background:var(--warn-soft);color:var(--warn)}
.met-scope .sub-pill.past{background:var(--accent-soft);color:var(--accent)}
.met-scope .vprofile{color:var(--accent);font-weight:600;text-decoration:none;white-space:nowrap;cursor:pointer}
.met-scope .vprofile:hover{text-decoration:underline}
.met-scope .t-price{font-size:12px;color:var(--faint);margin-top:4px}
.met-scope .adot{position:absolute;right:-1px;bottom:-1px;width:12px;height:12px;border-radius:50%;border:2px solid var(--surface);box-sizing:border-box}
/* One state only, on purpose: the dot means ONLINE NOW. Offline renders no dot at
   all rather than a grey one, so the dot can never be misread as a status badge.
   The old .active/.dormant/.suspended colours were account status (WEB-68). */
.met-scope .adot.online{background:var(--good)}
.met-scope .acct-pill{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:700;padding:3px 9px;border-radius:999px}
.met-scope .acct-pill i{width:7px;height:7px;border-radius:50%}
/* One class per CANONICAL status (deleted > deactivated > suspended > approved >
   hidden > inactive > ghost; utils/memberStatus.js) — the drawer's Account pill
   renders that machine and nothing
   else. The '.dormant' class is gone: it was this page's own invented state, and
   it read
   "Dormant" over 5 canonically ACTIVE members (idle 30d) plus 2 deactivated and
   1 ghost, contradicting the Subscription Report row the drawer opens from.
   .active is kept only for rows from a pre-v3 server; approved takes its colours. */
.met-scope .acct-pill.approved,.met-scope .acct-pill.active{background:var(--good-soft);color:var(--good)} .met-scope .acct-pill.approved i,.met-scope .acct-pill.active i{background:var(--good)}
.met-scope .acct-pill.inactive{background:#EFEFF1;color:var(--soft)} .met-scope .acct-pill.inactive i{background:var(--accent)}
.met-scope .acct-pill.deactivated{background:var(--warn-soft);color:var(--warn)} .met-scope .acct-pill.deactivated i{background:var(--warn)}
.met-scope .acct-pill.hidden{background:var(--warn-soft);color:var(--warn)} .met-scope .acct-pill.hidden i{background:var(--warn)}
.met-scope .acct-pill.ghost{background:#EFEFF1;color:var(--soft)} .met-scope .acct-pill.ghost i{background:var(--soft)}
.met-scope .acct-pill.suspended{background:var(--accent-soft);color:var(--accent)} .met-scope .acct-pill.suspended i{background:var(--accent)}
.met-scope .acct-pill.deleted{background:var(--accent-soft);color:var(--accent)} .met-scope .acct-pill.deleted i{background:var(--accent)}
.met-scope .legendline{display:flex;gap:16px;align-items:center;font-size:12px;color:var(--soft);margin:0 0 12px;flex-wrap:wrap}
.met-scope .legendline .k{display:inline-flex;align-items:center;gap:6px}
.met-scope .legendline .k i{width:9px;height:9px;border-radius:50%}
.met-scope th.sortable{cursor:pointer;user-select:none;white-space:nowrap}
.met-scope th.sortable:hover{color:var(--ink)}
.met-scope th.sortable .ar{display:inline-block;margin-left:5px;font-size:10px;opacity:.3;transition:.15s}
.met-scope th.sortable.active-sort .ar{opacity:1;color:var(--accent)}
@media(prefers-reduced-motion:reduce){.met-scope *{transition:none!important}}

/* ---- Responsive: tablet & mobile ------------------------------------------
   The tracker was authored desktop-first. These breakpoints keep the KPI cards,
   filter controls and the detail drawer usable on every device: KPI columns and
   value type scale down so large figures (e.g. "₹20,000/mo") never overflow,
   the search/chips/sort controls stack and go full-width, and the drawer's
   3-up stat grid collapses inside the narrow (94vw) mobile drawer. The data
   table keeps its own horizontal scroll (.scroll), so it is left untouched. */
@media (max-width:768px){
  .met-scope .kpis{grid-template-columns:repeat(2,1fr);gap:12px}
  .met-scope .kpi{padding:14px 15px}
  .met-scope .kpi .val{font-size:18px}
  .met-scope .kpi .val small{font-size:12px}
  .met-scope .kpi .note{font-size:11.5px}
  .met-scope .dstats{grid-template-columns:repeat(2,1fr)}
  .met-scope .dhead{padding:16px 18px}
  .met-scope .dbody{padding:16px 18px 26px}
  .met-scope .dhead h2{font-size:20px}
}
@media (max-width:560px){
  .met-scope .controls{flex-direction:column;align-items:stretch}
  .met-scope .search{min-width:0;width:100%}
  .met-scope .chips{width:100%;justify-content:space-between}
  .met-scope select.sort{width:100%}
}
@media (max-width:430px){
  .met-scope .kpis{grid-template-columns:1fr}
  .met-scope .kpi .val{font-size:18px}
  .met-scope .dstats{grid-template-columns:1fr 1fr}
  .met-scope .dstat .v{font-size:18px}
  .met-scope .bubble{max-width:90%}
}
`;

export default css;
